<template>
  <div
    class="content"
    :class="!isUle?'headStyle':''"
    id="scroll1"
    ref="content"
    :style="{'height':scrollHeight}"
  >
    <!-- <h5-header v-if="!isUle" :class="!isUle?'h5headStyle':''"></h5-header> -->
    <download-head v-if="!isUle&&!isUcbank"></download-head>
    <header>
      <img class="head-bgImg" v-for="item in headImgArr" :src="item" :key="item" alt />
      <div class="activites" v-if="isShowFish=='1'">
        <div class="activites-bg hbx-main" @click.prevent="hbGame" data-stat="疯狂红包雨-进入红包雨">
          <img
            :src="redkaiqiif?closeMsgBtn:openMsgBtn"
            @click.stop="openMsg"
            data-stat="疯狂红包雨-打开/关闭红包雨提示"
            alt
          />
        </div>
        <div class="activites-bg axc-main" @click="axcGame" data-stat="欢乐钓鱼-进入欢乐钓鱼游戏">
          <img src="//i0.ulecdn.com/i/event/2019/0919/main/images/axc_btn.png" alt />
        </div>
      </div>
      <div
        class="preheat-active"
        v-if="isShowFish=='0'"
        @click.prevent="hbGame"
        data-stat="疯狂红包雨-进入红包雨"
      >
        <img class="bg" src="//i0.ulecdn.com/i/event/2019/0919/main/images/preheat_one1.png" alt />
        <img
          class="bg"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/preheat_two2.png"
          style="margin-top:-1px;"
          alt
        />
        <img
          class="btn"
          :src="redkaiqiif?closeMsgBtn:openMsgBtn"
          @click.stop="openMsg"
          data-stat="疯狂红包雨-打开/关闭红包雨提示"
        />
      </div>
      <img
        class="header-title"
        src="//i0.ulecdn.com/i/event/2019/0919/main/images/header_title.png?v=1"
        alt
      />
      <head-animation></head-animation>
    </header>
    <nav-menu
      :scrollTop="scrollTop"
      :showMenuIndex="showMenuIndex"
      :type="1"
      :navMain="navMain"
      :navColor="'#ce2c00'"
    ></nav-menu>
    <div class="main">
      <div class="cj-main" id="xdydj">
        <img
          class="cj-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/cj_header4.png?v=2"
          alt
        />
        <div class="rule-icon2" @click="dwRecommond(2002,'xdydj')" data-stat="下单抽奖-查看规则"></div>
        <div class="cj-con">
          <img
            class="rule-icon"
            src="//i0.ulecdn.com/i/event/2019/0919/main/images/rule_icon.png"
            alt
          />
          <img class="cj-bg" src="//i0.ulecdn.com/i/event/2019/0919/main/images/cj_bg.png" alt />
          <img
            class="cj-btn"
            :class="clickBtn?'cj-btn-two':''"
            @click="clickCssFun"
            data-stat="下单赢大奖-抽奖"
            src="//i0.ulecdn.com/i/event/2019/0919/main/images/cj_btn.png"
            alt
          />
          <img class="shou" src="//i0.ulecdn.com/i/event/2019/0919/main/images/shou.png" alt />
          <div class="cj-text">
            已消耗
            <span>{{usedTimes}}</span>次活动资格
            <br />还剩
            <span>{{cjTimes.times}}</span>次抽奖资格
          </div>
        </div>
      </div>
      <div class="qd-main" id="ttqd">
        <img
          class="qd-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/qd_header4.png?v=2"
          alt
        />
        <div class="rule-icon2" @click="dwRecommond(2002,'ttqd')" data-stat="天天签到-查看规则"></div>
        <div class="qd-con backgroundImgtwo">
          <img
            class="rule-icon"
            src="//i0.ulecdn.com/i/event/2019/0919/main/images/rule_icon.png"
            alt
          />
          <img
            v-show="isSign"
            class="qd-label"
            src="//i0.ulecdn.com/i/event/2019/0919/main/images/qd_label.png"
            alt
          />
          <div class="times-con">
            <img src="//i0.ulecdn.com/i/event/2019/0919/main/images/qd_times.png" alt />
            <p>{{signedTimes}}</p>
          </div>
          <p class="qd-text">活动期间，累计签到满5天，即可获得邮乐全场通用券</p>
          <div class="qd-times">
            <div class="times-item" v-for="i in 4" :key="i">
              <img
                v-if="i<signedTimes"
                class="point"
                src="//i0.ulecdn.com/i/event/2019/0919/main/images/tims-item-active.png"
                alt
              />
              <img
                v-if="i==signedTimes"
                class="point pointThree"
                src="//i0.ulecdn.com/i/event/2019/0919/main/images/tims-item-fire.png"
                alt
              />
              <img
                v-if="i>signedTimes"
                class="point"
                src="//i0.ulecdn.com/i/event/2019/0919/main/images/tims-item-defult.png"
                alt
              />
              <img
                v-show="i<signedTimes"
                class="times-line"
                src="//i0.ulecdn.com/i/event/2019/0919/main/images/jindu_bgact.png"
                alt
              />
              <img
                v-if="signedTimes!=5&&i==4"
                class="point point-two"
                src="//i0.ulecdn.com/i/event/2019/0919/main/images/tims-item-defult.png"
                alt
              />
              <img
                v-if="signedTimes>=5&&i==4"
                class="point point-two"
                src="//i0.ulecdn.com/i/event/2019/0919/main/images/tims-item-fire.png"
                alt
              />
            </div>
            <img
              class="get-hb"
              v-show="isGethb"
              @click="qdGetHbFun"
              data-stat="天天签到-红包领取"
              src="//i0.ulecdn.com/i/event/2019/0919/main/images/get_hb.png"
              alt
            />
            <img
              class="get-hb"
              v-show="!isGethb"
              src="//i0.ulecdn.com/i/event/2019/0919/main/images/no_get_hb.png"
              alt
            />
          </div>
          <img
            v-show="signedTimes<5"
            class="qd-btn"
            @click="signFun"
            data-stat="天天签到-签到"
            :src="isSign?signBtn.disableBtn:signBtn.activeBtn"
            alt
          />
          <img
            v-show="signedTimes==5"
            class="qd-btn"
            @click="qdGetHbFun"
            data-stat="天天签到-红包领取2"
            :src="isGethb?gethbBtn.activeBtn:gethbBtn.disableBtn"
            alt
          />
        </div>
      </div>
      <div class="list-main" id="myfn" v-show="myfnList&&myfnList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/myfn_header2.png?v=1"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/ulenp/event/2019/0919/wap.html')"
          data-stat="扶贫专区-查看更多"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="myfnList" :type="6" :isStart="true"></con-list>
      </div>
      <div class="list-main" id="czhg" v-show="czhgList&&czhgList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/czhg_header3.png?v=1"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/event/tmpl/ulewap.html?actId=301')"
          data-stat="超值惠购-查看更多"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="czhgList" :type="1" :isStart="true" style="margin-top:-23px"></con-list>
      </div>
      <div class="list-main" id="tgjsh" v-show="tgjshList&&tgjshList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/tg_header2.png?v=1"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/event/activity/20180331/group/index.html')"
          data-stat="团购聚实惠-查看更多"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="tgjshList" :type="2" :isStart="true"></con-list>
      </div>
      <div class="list-main" id="ylswh" v-show="ylswhList&&ylswhList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/35_header2.png?v=1"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/event/2019/0614/35h/index.html')"
          data-stat="邮乐三五惠-查看更多"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="ylswhList" :type="3" :isStart="true"></con-list>
      </div>
      <div class="list-main" id="yczq" v-show="yczqList&&yczqList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/yc_header2.png?v=1"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/event/2019/0813/H5.html?adid=psbc_yl_appzhc')"
          data-stat="邮储专区-查看更多"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="yczqList" :type="4" :isStart="true"></con-list>
      </div>

      <div class="list-main" id="wntj" v-show="wntjList&&wntjList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/tj_header2.png?v=1"
          data-stat="为您推荐-查看更多"
          alt
        />
        <con-list :list="wntjList" :type="5" :isStart="true"></con-list>
      </div>
    </div>
    <!-- <slider-menu :type="1"></slider-menu> -->
    <hb-alert
      v-if="redifbox"
      :sysTime="sysTime"
      :isLogin="isLogin"
      :redactivityCode="redactivityCode"
      @closeAlert="closeAlert"
    ></hb-alert>
    <cj-alert
      v-if="isShowCjalert"
      @cjAlertState="cjAlertState"
      :alertMain="alertMain"
      @shareMaskState="shareMaskState"
    ></cj-alert>
    <rule-alert @isRuleAlert="isRuleAlert" v-if="isShowRule" :ruleText="ruleText"></rule-alert>
    <share-mask :shareMask="shareMask" @closeShareMask="closeShareMask"></share-mask>
    <tab-bar :type="1"></tab-bar>
  </div>
</template>

<script>
import Vue from "vue";
import navMenu from "../common/navMenu";
import conList from "../common/list";
import sliderMenu from "../common/sliderMenu";
import hbAlert from "../common/alert";
import headAnimation from "../common/animation";
import cjAlert from "../common/cjAlert";
import downloadHead from "../common/downloadHead";
import h5Header from "../common/head";
import ruleAlert from "../common/ruleAlert";
import tabBar from "../common/tabBar";
import shareMask from "../common/shareMask";
import { Toast } from "mint-ui";
import * as URL from "../../assets/js/url.js";
export default {
  props: ["isUcbank"],
  data() {
    return {
      showMain: false,
      scrollHeight: document.documentElement.clientHeight + "px",
      headImgArr: [
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_01.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_02.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_03.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_04.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_05.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_06.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_07.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_08.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_09.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_10.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_12.jpg?v=1"
      ],
      signedTimes: 0, //已签到次数
      isSign: false, //当天是否已签到
      isShowHeader: false,
      isShowCjalert: false, //是否显示抽奖弹框
      scrollTop: 0, //滚动条位置
      showMenuIndex: 1, //默认激活第一个菜单
      themeCodes: {}, //主题code及活动code
      betathemeCodes: {
        hbthemeCode: "156533367209345", //红包雨主题code
        mqthemeCode: "156585821522437" //满签抽奖主题code
      }, //主题code及活动code
      prdthemeCodes: {
        hbthemeCode: "156533367209345", //红包雨主题code
        mqthemeCode: "156585821522437" //满签抽奖主题code
      }, //主题code及活动code
      // signConfigNo: "SIGN_156560029870452", //签到号
      signConfigNo: "SIGN_156586350887720", //签到号
      sysTime: null, //系统时间
      redstart: null, //活动开始时间
      redend: null, //活动结束时间
      rodcshu: 1,
      redif: false, //红包开始状态判断
      redactivityCode: "", //活动code
      redifbox: false, //是否展示红包红包雨提示层
      userOnlyId: "", //用户id
      isUle: false, //是否app客户端环境
      redkaiqiif: false, //是否开启消息通知
      closeMsgBtn: require("../../assets/images/close_msg2.png"),
      openMsgBtn: require("../../assets/images/hby_btn2.png"),
      signBtn: {
        //签到按钮
        activeBtn: require("../../assets/images/signed.png"),
        disableBtn: require("../../assets/images/axc_disable_btn.png")
      },
      gethbBtn: {
        //签到按钮
        activeBtn: require("../../assets/images/gethb_btn_one.png"),
        disableBtn: require("../../assets/images/getedhb_btn_one.png")
      },
      qd_shareActivityCode: "MA_U_156713286094377", //签到抽奖分享活动code
      cj_shareActivityCode: "MA_U_156714801187606", //下单抽奖分享活动code
      activityCode: "", //红包雨活动code、
      apiCode: [], //广告推荐位,天天签到、下单赢大奖
      betaApiCode: ["event_2019919_qd_rule", "event_2019919_prize_rule"], //广告推荐位,天天签到、下单赢大奖
      prdApiCode: ["event_2019919_qd_rule", "event_2019919_prize_rule"], //广告推荐位,天天签到、下单赢大奖
      betaModuleKeys: [
        "event_2019919_07",
        "event_2019919_03",
        "event_2019919_04",
        "event_2019919_05",
        "event_2019919_06",
        "event_2019919_09"
      ],
      prdModuleKeys: [
        "event_2019919_07",
        "event_2019919_03",
        "event_2019919_04",
        "event_2019919_05",
        "event_2019919_06",
        "event_2019919_09"
      ],
      moduleKeys: [], //普通商品推荐位
      activityCodeArr: [], //抽奖资格活动code
      betaActivityCodeArr: [
        "MA_U_156654967528207",
        "MA_U_156635764501476",
        "MA_U_156635795682521"
      ],
      prdActivityCodeArr: [
        "MA_U_156690237658291",
        "MA_U_156690321600510",
        "MA_U_156690429177068"
      ],
      alertMain: {
        type: 1, //弹框显示类型0签到成功，1普通文字，2奖励金，3商品券
        text: "", //抽奖弹框显示文字
        days: "", //距离抽奖天数
        ticketInfo: {
          collectionId: null,
          expiredEndDate: "",
          expiredStartDate: "",
          fullcutAmountLimit: 0,
          pcBatchId: "",
          prizeDesc: "",
          prizeMoney: null,
          prizeType: "",
          prizeTypeDesc_v2: "",
          text_url: "",
          collectionName: ""
        }
      },
      isGethb: false, //是否有签到领红包资格
      qdCode: {
        activityCode: "",
        fieldId: ""
      },
      cjTimes: {
        totalTimes: 0,
        times: 0
      },
      threeTypeTimes: {
        //三种抽奖资格对应抽奖次数
        xsdTimes: 0,
        ldxTimes: 0,
        xyhTimes: 0
      },
      czhgList: [], //超值惠购数据列表
      tgjshList: [], //团购聚实惠数据列表
      ylswhList: [], //邮乐三五惠数据列表
      yczqList: [], //邮储专区数据列表
      wntjList: [], //为您推荐数据列表
      myfnList: [], //名优扶农数据列表
      isShowRule: false,
      ruleText: "", //规则
      isLogin: false, //用户登录状态
      clickBtn: false,
      shareMask: false,
      lottryType: null, //分享抽奖类型0签到分享抽奖，1下单抽奖分享
      navMain: [
        {
          id: "xdydj",
          name: "下单赢大奖"
        },
        {
          id: "ttqd",
          name: "天天签到"
        },
        {
          id: "myfn",
          name: "扶贫专区"
        },
        {
          id: "czhg",
          name: "超值惠购"
        },
        {
          id: "tgjsh",
          name: "团购聚实惠"
        },
        {
          id: "ylswh",
          name: "邮乐三五惠"
        },
        {
          id: "yczq",
          name: "邮储专区"
        },

        {
          id: "wntj",
          name: "为您推荐"
        }
      ],
      redimgdata: "",
      isShowFish: "1"
    };
  },
  created() {
    // this.isGethb = true;
    // this.isShowCjalert = true;
    // let ticketInfo = {
    //   collectionId: 6120,
    //   expiredEndDate: "2018-12-31",
    //   expiredStartDate: "2018-12-29",
    //   fullcutAmountLimit: 0,
    //   pcBatchId: "694691",
    //   prizeDesc: "仅限邮乐网使用",
    //   prizeMoney: 0.2,
    //   prizeType: "优惠券",
    //   prizeTypeDesc_v2: "10102",
    //   text_url: "",
    //   collectionName: "50元无门槛优惠券"
    // };
    // this.alertMain = {
    //   type: 3,
    //   ticketInfo: ticketInfo,
    //   lottryType: 0,
    //   shareLottry: 1
    // };
    this.initCode();
    this.isUle = this.BASE.$browser().ule;
    this.datetime(); //获取系统时间
    this.getUserinfo();
    this.initOpenMsg();
    this.dwRecommond(2001); //普通商品推荐位
    setTimeout(() => {
      this.showMain = true;
    }, 100);
    this.initHeadShare();
  },
  mounted() {
    let urlFish = this.BASE.getUrlStr("isFish");
    let indexFish = document
      .getElementById("isShowFish")
      .getAttribute("isShowFish");
    this.isShowFish = urlFish ? urlFish : indexFish;
    console.log("钓鱼是否显示" + this.isShowFish);
    // 绑定监听事件
    // window.addEventListener("scroll", this.handleScroll, true);
    document
      .getElementById("scroll1")
      .addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    initHeadShare() {
      if (this.isUle) {
        var shareObj = {
          shareType: "111",
          title: "今年919格外不一样，优惠不停等你来！",
          content: "919丰收欢乐购，1亿购物津贴等你领！",
          imageUrl:
            "https://i0.ulecdn.com/i/event/2019/0919/main/images/shareLogo.png",
          linkUrl: location.href,
          logTitle: "919主会场"
        };
        let that = this;
        that.setTitle(document.title, {
          imgUrl:
            "https://i0.ulecdn.com/i/global/share" +
            (that.BASE.$browser().ios ? "56" : "72") +
            ".png",
          type: "2",
          ios_action: JSON.stringify(shareObj),
          android_action: JSON.stringify(shareObj)
        });
      }
    },
    // 设置标题栏
    setTitle(title, right) {
      var params = {
        title: title || document.title
      };
      if (right) {
        params.rightIcon = [right];
      }
      dsBridge.call("setNativeTitle", params);
    },
    // dsBridge判断
    dsBridgeCheck(callback, trynum) {
      var that = this;
      trynum = trynum || 1;
      if (window.dsBridge) {
        setTimeout(function() {
          callback();
        }, 100);
      } else if (trynum <= 20) {
        setTimeout(function() {
          trynum++;
          dsBridgeCheck(callback, trynum);
        }, 100);
      }
    },
    initCode() {
      if (process.env.NODE_ENV == "production") {
        //生产环境
        this.themeCodes = this.prdthemeCodes;
        this.apiCode = this.prdApiCode;
        this.moduleKeys = this.prdModuleKeys;
        this.activityCodeArr = this.prdActivityCodeArr;
      } else {
        //beta环境
        this.themeCodes = this.betathemeCodes;
        this.apiCode = this.betaApiCode;
        this.moduleKeys = this.betaModuleKeys;
        this.activityCodeArr = this.betaActivityCodeArr;
      }
    },
    cjAlertState(data) {
      this.isShowCjalert = data.cjAlertState;
      //分享抽奖
      if (data.shareLottry == 0) {
        //签到分享抽奖
        this.lottry(this.qd_shareActivityCode, "share");
      } else if (data.shareLottry == 1) {
        //下单分享抽奖
        this.lottry(this.cj_shareActivityCode, "share");
      }
    },
    shareMaskState(data) {
      this.shareMask = true;
      this.lottryType = data;
    },
    //app分享抽奖
    shareLottryTwo(data) {
      if (data == 0) {
        //签到分享抽奖
        this.lottry(this.qd_shareActivityCode, "share");
      } else if (data == 1) {
        //下单分享抽奖
        this.lottry(this.cj_shareActivityCode, "share");
      }
    },
    //h5下关闭分享遮罩层进行分享抽奖
    closeShareMask(data) {
      this.shareMask = data;
      if (this.lottryType == 0) {
        //签到分享抽奖
        this.lottry(this.qd_shareActivityCode, "share");
      } else if (this.lottryType == 1) {
        //下单分享抽奖
        this.lottry(this.cj_shareActivityCode, "share");
      }
    },
    toOthers(link) {
      location.href = link;
    },
    isRuleAlert(data) {
      this.isShowRule = data;
    },
    dwRecommond(type, flag) {
      var timestamp = Date.parse(new Date());
      let path, jsonpCallback;
      if (type == 2002) {
        //广告推荐位
        jsonpCallback = "jsonp31";
        path =
          jsonpCallback +
          "/" +
          type +
          "/0/" +
          this.apiCode.join("-") +
          "/" +
          this.apiCode.join("-") +
          ".html?timestamp=" +
          timestamp;
      } else {
        //普通商品推荐位
        jsonpCallback = "jsonp32";
        path =
          jsonpCallback +
          "/" +
          type +
          "/0/" +
          this.moduleKeys.join("-") +
          "/" +
          this.moduleKeys.join("-") +
          ".html?timestamp=" +
          timestamp;
      }
      this.HTTP.dwRecommond(path, jsonpCallback)
        .then(res => {
          if (type == 2002) {
            this.initRule(res, flag); //活动规则
          } else if (type == 2001) {
            this.initList(res, this.moduleKeys); //商品列表
          }
        })
        .catch(err => {
          let jsonData = require("../../assets/js/dwRecommond.json");
          let dwRecommondData = localStorage.dwRecommondData
            ? JSON.parse(localStorage.dwRecommondData)
            : jsonData;
          this.initList(dwRecommondData, this.moduleKeys); //商品列表
        });
    },
    initRule(res, flag) {
      this.isShowRule = true;
      this.ruleText = "";
      if (flag == "ttqd") {
        //天天签到规则
        for (let i = 0; i < res[this.apiCode[0]].length; i++) {
          this.ruleText =
            this.ruleText + "<p>" + res[this.apiCode[0]][i].title + "</p>";
        }
      } else if (flag == "xdydj") {
        //下单赢大奖规则
        for (let i = 0; i < res[this.apiCode[1]].length; i++) {
          this.ruleText =
            this.ruleText + res[this.apiCode[1]][i].title + "<br />";
        }
      }
    },
    initList(res, moduleKeys) {
      this.czhgList = this.skillPrice(res[moduleKeys[0]]); //超值惠购

      let tgData = res[moduleKeys[1]],
        newTgData = [];
      for (let i = 0; i < tgData.length; i++) {
        if (JSON.parse(tgData[i].promotionDesc)) {
          let groupPrice = JSON.parse(tgData[i].promotionDesc).rules[0]
            .groupbuyPrice;
          tgData[i].groupbuyPrice = groupPrice;
        }
        newTgData.push(tgData[i]);
      }
      this.tgjshList = newTgData; //团购聚实惠数据列表

      this.ylswhList = this.skillPrice(res[moduleKeys[2]]); //邮乐三五惠数据列表
      this.yczqList = this.skillPrice(res[moduleKeys[3]]); //邮储专区数据列表
      this.wntjList = res[moduleKeys[4]]; //为您推荐数据列表
      this.myfnList = res[moduleKeys[5]]; //名优扶农数据列表
    },
    skillPrice(arr) {
      let skillData = arr,
        newSkillData = [];
      for (let i = 0; i < skillData.length; i++) {
        if (JSON.parse(skillData[i].promotionDescTwo)) {
          let skillPrice = JSON.parse(skillData[i].promotionDescTwo)
            .listingSeckillPrice;
          skillData[i].skillPrice = skillPrice;
        } else {
          let skillPrice = skillData[i].minPrice;
          skillData[i].skillPrice = skillPrice;
        }
        newSkillData.push(skillData[i]);
      }
      return newSkillData;
    },
    initOpenMsg() {
      if (this.isUle) {
        let m = this;
        dsBridge.call("getH5AlarmsStatus", m.themeCodes.hbthemeCode, function(
          ret
        ) {
          if (ret == "true") {
            m.redkaiqiif = true;
          } else {
            m.redkaiqiif = false;
          }
        });
      }
    },

    getUserinfo() {
      if (!this.BASE.getCookie("mall_cookie")) {
        sessionStorage.clear();
        this.isLogin = false;
      } else {
        if (
          sessionStorage.userOnlyId &&
          sessionStorage.userOnlyId != undefined
        ) {
          this.userOnlyId = sessionStorage.userOnlyId;
          this.isLogin = true;
          this.getsignCount(); //获取签到次数
          this.getBatchActivityTimes(); //下单赢大奖抽奖资格查询
        } else {
          this.HTTP.getIndexCookies()
            .then(res => {
              if (!res.loginname && !res.mall_cookie) {
                //用户未登录
                this.isLogin = false;
              } else {
                //已登录
                sessionStorage.userOnlyId = res.useronlyid;
                this.isLogin = true;
                this.userOnlyId = res.useronlyid;
                this.getsignCount(); //获取签到次数
                this.getBatchActivityTimes(); //下单赢大奖抽奖资格查询
              }
            })
            .catch(err => {});
        }
      }
    },
    getsignCount() {
      this.HTTP.querySingCount(this.signConfigNo, this.userOnlyId)
        .then(res => {
          if (res.code == "0000") {
            this.signedTimes = res.content.singCount; //已签到次数
            this.isSign = res.content.flag; //是否已签到
            //签到次数为5天去查询抽奖资格（先查活动场次再查抽奖资格）
            if (this.signedTimes >= 5) {
              this.getcjActivityTimes(); //获取满签抽奖活动场次
            }
          } else {
            Toast(res.message);
          }
        })
        .catch(err => {});
    },
    getcjActivityTimes() {
      this.HTTP.getActivityInfos(this.themeCodes.mqthemeCode, "jsoncallback13")
        .then(res => {
          console.log("查询成功了满签场次");
          let data = res;
          if (res.code == "0000") {
            this.HTTP.datetime()
              .then(res => {
                this.sysTime = new Date(res.time);
                this.eachcjActivityTimes(data); //处理签到抽奖活动场次信息
              })
              .catch(err => {});
          } else {
            Toast(res.message);
          }
        })
        .catch(err => {
          console.log("查询失败了满签场次");
        });
    },
    //处理签到抽奖活动场次信息
    eachcjActivityTimes(res) {
      var m = this;
      var fieldId, activityCode;
      for (var i = 0; i < res.content.length; i++) {
        var datetime; //活动开始期间
        var datetimeent; //活动结束时间
        for (var j = 0; j < res.content[i].fieldInfos.length; j++) {
          datetime = res.content[i].fieldInfos[j].startTime.replace(/-/g, "/");
          datetimeent = res.content[i].fieldInfos[j].endTime.replace(/-/g, "/");
          if (new Date(datetime).getDate() == m.sysTime.getDate()) {
            if (
              Math.max(new Date(datetime).getTime() - m.sysTime.getTime(), 0) /
                1000 <=
                0 &&
              Math.max(
                new Date(datetimeent).getTime() - m.sysTime.getTime(),
                0
              ) /
                1000 >
                0
            ) {
              fieldId = res.content[i].fieldInfos[j].fieldId;
              activityCode = res.content[i].activityCode;
            }
          }
        }
      }
      //查询抽奖资格
      if (activityCode && fieldId) {
        this.getCjTimes(activityCode, fieldId);
      } else {
        console.log("当前时间没有对应的满签抽奖活动场次");
      }
    },
    getCjTimes(activityCode, fieldId) {
      //查询签到抽奖资格
      this.HTTP.getActivityTimes(activityCode, fieldId, this.userOnlyId)
        .then(res => {
          if (res.code == "0000") {
            //保存签到抽奖当前活动code和fieldId
            this.qdCode = {
              activityCode: activityCode,
              fieldId: fieldId
            };
            if (res.content[0].times == "-99" || res.content[0].times > 0) {
              //有抽奖资格
              this.isGethb = true;
            } else {
              this.isGethb = false;
            }
          } else {
            this.isGethb = false;
          }
        })
        .catch(err => {});
    },
    //签到五天抽奖
    qdGetHbFun() {
      //未登录先登录
      if (!this.isLogin) {
        this.login();
        return;
      }
      if (this.isUle) {
        //无领红包资格时点击无反应
        if (!this.isGethb) {
          return;
        }
        this.HTTP.lottry(
          this.qdCode.activityCode,
          this.qdCode.fieldId,
          this.userOnlyId
        )
          .then(res => {
            this.isShowCjalert = true;
            console.log("当前签到抽奖奖品结果为：" + res.code + res.message);
            if (res.code == "0000") {
              if (res.content.prizeInfos[0].prizeType == "鼓励金") {
                //鼓励金
                this.alertMain = {
                  type: 2,
                  ticketInfo: res.content.prizeInfos[0],
                  lottryType: 0,
                  shareLottry: 0
                };
              } else if (res.content.prizeInfos[0].prizeType == "优惠券") {
                //优惠券
                this.alertMain = {
                  type: 3,
                  ticketInfo: res.content.prizeInfos[0],
                  lottryType: 0,
                  shareLottry: 0
                };
              }
            } else if (res.code == "1000") {
              //谢谢参与
              this.alertMain = {
                type: 1,
                text: "很遗憾！您与大奖擦肩而过"
              };
            } else if (res.code == "1003") {
              this.alertMain = {
                type: 1,
                text: "抱歉！您暂无活动资格"
              };
            } else {
              this.alertMain = {
                type: 1,
                text: "很遗憾！您与大奖擦肩而过"
              };
            }
            //查询抽奖资格
            this.getCjTimes(this.qdCode.activityCode, this.qdCode.fieldId);
          })
          .catch(err => {});
      } else {
        this.BASE.openApp();
      }
    },

    //签到
    signFun() {
      //未登录先登录
      if (!this.isLogin) {
        this.login();
        return;
      }
      if (this.isUle) {
        //邮乐app内
        if (!this.isSign) {
          //当天未签到
          this.HTTP.signup(this.signConfigNo)
            .then(res => {
              if (res.code == "0000") {
                let days = 4 - Number(this.signedTimes);
                this.isShowCjalert = true;
                this.alertMain.type = 0; //显示签到成功弹框
                if (days > 0) {
                  this.alertMain.days = "距离获取大奖还有" + days + "天";
                } else {
                  this.alertMain.days = "赶快领取签到奖励吧";
                }
                this.getsignCount(); //重新查询签到次数
              } else {
                Toast(res.message);
              }
            })
            .catch(err => {
              Toast(err.message);
            });
        }
      } else {
        this.BASE.openApp();
      }
    },
    login() {
      if (this.isUle) {
        location.href = "uleMobile://uleLogin_" + location.href;
      } else {
        location.href =
          "//m." +
          URL.doMain +
          "/user/login?target=" +
          encodeURIComponent(location.href);
      }
    },
    datetime() {
      this.HTTP.datetime()
        .then(res => {
          this.sysTime = new Date(res.time);
          this.getActivityInfos(); //活动场次信息
        })
        .catch(err => {});
    },
    //进入切红包游戏
    hbGame() {
      //未登录先登录
      this.datetime();
    },
    getBatchActivityTimes() {
      this.HTTP.getBatchActivityTimes(
        this.activityCodeArr.join(","),
        this.userOnlyId
      )
        .then(res => {
          if (res.code == "0000") {
            this.totalTimes(res.content.activityTimeList); //抽奖资格数据统计
          }
        })
        .catch(err => {});
    },
    totalTimes(data) {
      let totalTimes = 0,
        times = 0; //总抽奖资格数量，剩余资格数量
      this.threeTypeTimes = {
        xsdTimes: data[0].times,
        ldxTimes: data[1].times,
        xyhTimes: data[2].times
      };
      for (let i = 0; i < data.length; i++) {
        if (data[i].totalTimes && data[i].totalTimes > 0) {
          //有固定次数抽奖资格总数
          totalTimes = totalTimes + data[i].totalTimes;
        } else if (data[i].totalTimes == "-99") {
          totalTimes = 99; //不限次数
        } else {
          //-99为不限次数抽奖资格，其他情况为没有抽奖资格总数
        }
        if (data[i].times && data[i].times > 0) {
          //有固定次数抽奖资格
          times = times + data[i].times;
        } else if (data[i].times == "-99") {
          times = 99; //不限次数
        } else {
          //-99为不限次数抽奖资格，其他情况为没有抽奖资格
        }
      }
      this.cjTimes = {
        totalTimes: totalTimes,
        times: times
      };
    },
    //抽奖活动抽奖方法
    clickCssFun() {
      this.clickBtn = true;
      let that = this;
      setTimeout(function() {
        that.clickBtn = false;
        that.cjGetHbFun();
      }, 50);
    },
    cjGetHbFun() {
      //未登录先登录
      if (!this.isLogin) {
        this.login();
        return;
      }
      if (this.cjTimes.times > 0) {
        //剩余抽奖次数大于0
        let activityCode;
        //抽奖资格调用顺序
        if (this.threeTypeTimes.xsdTimes > 0) {
          activityCode = this.activityCodeArr[0];
        } else if (this.threeTypeTimes.ldxTimes > 0) {
          activityCode = this.activityCodeArr[1];
        } else if (this.threeTypeTimes.xyhTimes > 0) {
          activityCode = this.activityCodeArr[2];
        }
        //抽奖
        this.lottry(activityCode);
      } else {
        this.isShowCjalert = true;
        this.alertMain = {
          type: 1,
          text: "抱歉！您暂无活动资格"
        };
      }
    },
    lottry(activityCode, type) {
      //抽奖
      this.HTTP.lottry(activityCode, " ", this.userOnlyId)
        .then(res => {
          console.log("当前抽奖奖品结果为：" + res.code + res.message);
          if (res.code == "0000") {
            //中奖了
            let shareLottry = 0;
            if (type == "share") {
              //分享抽奖时为1，其他抽奖为0，分享抽奖的不能再分享
              shareLottry = 1;
            } else {
              shareLottry = 0;
            }
            if (res.content.prizeInfos[0].prizeType == "鼓励金") {
              //鼓励金
              this.alertMain = {
                type: 2,
                ticketInfo: res.content.prizeInfos[0],
                lottryType: 1,
                shareLottry: shareLottry
              };
            } else if (res.content.prizeInfos[0].prizeType == "优惠券") {
              //优惠券
              this.alertMain = {
                type: 3,
                ticketInfo: res.content.prizeInfos[0],
                lottryType: 1,
                shareLottry: shareLottry
              };
            }
          } else if (res.code == "1000") {
            //谢谢参与
            this.alertMain = {
              type: 1,
              text: "很遗憾！您与大奖擦肩而过"
            };
          } else if (res.code == "1003") {
            this.alertMain = {
              type: 1,
              text: "抱歉！您暂无活动资格"
            };
          } else {
            this.alertMain = {
              type: 1,
              text: "很遗憾！您与大奖擦肩而过"
            };
          }
          this.isShowCjalert = true;
          //分享抽奖不使用正常抽奖资格，无需重新查询抽奖资格
          if (type != "share") {
            this.getBatchActivityTimes(); //下单赢大奖抽奖资格查询
          }
        })
        .catch(err => {});
    },
    //红包雨活动场次信息
    getActivityInfos() {
      var m = this,
        startDate,
        startif = false;

      m.rodcshu++;
      m.HTTP.getActivityInfos(m.themeCodes.hbthemeCode)
        .then(res => {
          if (res.code == "0000") {
            m.activityCode = res.content[0].activityCode; //活动code
            for (var i = 0; i < res.content.length; i++) {
              var datetime;
              var datetimeent;
              for (var j = 0; j < res.content[i].fieldInfos.length; j++) {
                datetime = res.content[i].fieldInfos[j].startTime.replace(
                  /-/g,
                  "/"
                );
                datetimeent = res.content[i].fieldInfos[j].endTime.replace(
                  /-/g,
                  "/"
                );
                if (new Date(datetime).getDate() == m.sysTime.getDate()) {
                  if (
                    Math.max(
                      new Date(datetime).getTime() - m.sysTime.getTime(),
                      0
                    ) /
                      1000 >
                    0
                  ) {
                    startDate = datetime;
                    startif = true;
                    if (m.rodcshu > 2) {
                      Toast("大侠，活动还没有开始！");
                    }
                    break;
                  } else if (
                    Math.max(
                      new Date(datetime).getTime() - m.sysTime.getTime(),
                      0
                    ) /
                      1000 <=
                      0 &&
                    Math.max(
                      new Date(datetimeent).getTime() - m.sysTime.getTime(),
                      0
                    ) /
                      1000 >
                      0
                  ) {
                    m.redstart = datetime;
                    m.redend = datetimeent;
                    m.redif = true;
                    m.redactivityCode = res.content[i].activityCode;
                    if (m.rodcshu > 2) {
                      window.location.href =
                        "//www." +
                        URL.doMain +
                        "/event/2019/0919/cutredbag/index.html?codeid=" +
                        m.redactivityCode;
                    }
                    break;
                  }
                }
              }
              if (!m.redif && m.rodcshu > 2) {
                Toast("大侠，活动还没有开始！");
              }
            }
            if (m.redif && m.rodcshu <= 2) {
              if (
                Math.max(
                  new Date(localStorage.getItem("redstarttime")).getTime() -
                    m.sysTime.getTime(),
                  0
                ) /
                  1000 <=
                  0 &&
                Math.max(
                  new Date(localStorage.getItem("redendtime")).getTime() -
                    m.sysTime.getTime(),
                  0
                ) /
                  1000 >
                  0
              ) {
              } else {
                m.redifbox = true;
              }
            }
          } else {
            Toast(res.message);
          }
        })
        .catch(err => {
          console.log(err);
          console.log("活动比较火爆等下再来！");
        });
    },
    //关闭红包提示层时执行
    closeAlert(value) {
      this.redifbox = false;
      localStorage.setItem("redstarttime", this.redstart);
      localStorage.setItem("redendtime", this.redend);
    },
    handleScroll(data) {
      this.$nextTick(() => {
        this.scrollTop = this.$refs.content.scrollTop;
        // this.$refs.content.scrollTop = 200;
        let height;
        if (this.isUle) {
          height = 45;
        } else {
          height = 85;
        }
        //获取各个楼层的滚动条高度并存储
        let offsetTopArr = [];
        if (offsetTopArr.length < 1 || !offsetTopArr) {
          //避免每一次滚动都重新获取元素位置数据
          for (let i = 0; i < this.navMain.length; i++) {
            let thisScroll =
              document.getElementById(this.navMain[i].id).offsetTop - height;
            offsetTopArr.push(thisScroll);
          }
        }
        this.showMenuIndex = this.BASE.navMenuIndex(
          this.scrollTop,
          offsetTopArr
        );
      });
    },
    //获取系统时间
    dataTime() {
      this.HTTP.datetime()
        .then(res => {
          console.log(res.time);
        })
        .catch(err => {});
    },
    //开启消息通知
    openMsg() {
      //未登录先登录
      if (!this.isLogin) {
        this.login();
        return;
      }
      if (this.isUle) {
        var m = this;
        var link =
          "https://www." + URL.doMain + "/event/2019/0919/main/index.html";
        var title = "邮政919 丰收欢乐购_天天签到 疯抢一亿红包_邮乐网APP";
        if (!m.redkaiqiif) {
          dsBridge.call(
            "setH5Alarms",
            {
              themeCode: m.themeCodes.hbthemeCode,
              title: "红包雨即将来袭",
              content: "倒计时！919疯狂红包雨即将来袭，1亿红包等你抢！",
              ios_action: "H5&&" + link + "&&0&&" + title,
              android_action: "H5&&" + link + "&&false&&" + title,
              maxversion: "999&999",
              minversion: "180&180",
              needlogin: "false"
            },
            function(ret) {
              if (ret == "true") {
                m.redkaiqiif = true;
              }
            }
          );
        } else {
          dsBridge.call("cancelH5Alarms");
          m.redkaiqiif = false;
        }
      } else {
        this.BASE.openApp();
      }
    },
    //进入爱消除游戏
    axcGame() {
      //用户未登录先登录
      if (!this.isLogin) {
        this.login();
        return;
      }
      location.href = "https://h5.tom.cn/ule/game/oauth/254";
      // if (this.BASE.$browser().ios && this.BASE.$browser().ule) {
      //   //ios客户端app下单独处理
      //   dsBridge.call("generalAction", {
      //     type: "3",
      //     ios_action:
      //       "DetailWebViewController::0&&key::https://h5.tom.cn/ule/game/oauth/254##title::欢乐捕鱼",
      //     android_action: "",
      //     maxversion: "999&999",
      //     minversion: "100&100",
      //     needlogin: "false",
      //     logTitle: ""
      //   });
      // } else {
      //   location.href = "https://h5.tom.cn/ule/game/oauth/254";
      // }
    }
  },
  computed: {
    signTimes() {
      return 5 - this.signedTimes;
    },
    //已消耗资格是资格总数减去剩余次数
    usedTimes() {
      return this.cjTimes.totalTimes - this.cjTimes.times;
    }
  },
  destroyed() {
    // 销毁绑定
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
    navMenu,
    conList,
    sliderMenu,
    hbAlert,
    headAnimation,
    cjAlert,
    downloadHead,
    h5Header,
    ruleAlert,
    tabBar,
    shareMask
  }
};
</script>

<style lang="less" scoped>
.headStyle {
  padding-top: 40px;
}
//隐藏滚动条
.content::-webkit-scrollbar {
  display: none;
  width: 0px;
}
.content {
  overflow-y: scroll;
  box-sizing: border-box;
  padding-bottom: 1.7rem;
  over-flow: auto; /* winphone8和android4+ */
  -webkit-overflow-scrolling: touch; /* ios5+ */
  header {
    position: relative;
    overflow: hidden;
    min-height: 70vh;
    .head-bgImg {
      display: block;
      width: 100%;
      float: left;
      font-size: 0;
      // margin-top: -1px;
    }
    .header-title {
      position: absolute;
      top: 8%;
      z-index: 4;
      width: 80%;
      left: 10%;
    }
    .preheat-active {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0.3rem;
      position: absolute;
      bottom: 0.1rem;
      z-index: 3;
      overflow: hidden;
      .bg {
        display: block;
        width: 100%;
        float: left;
        font-size: 0;
      }
      .btn {
        position: absolute;
        bottom: 0.25rem;
        width: 38%;
        left: 31%;
      }
    }
    .activites {
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 0.2rem;
      width: 100%;
      position: absolute;
      bottom: 0.1rem;
      z-index: 3;
      .activites-bg {
        width: 49%;
        height: 2.9rem;
        position: relative;
      }
      .hbx-main {
        background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/hby_bg.png")
          no-repeat;
        background-size: 100% 100%;
        float: left;
      }
      .axc-main {
        background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/axc_bg2.png")
          no-repeat;
        background-size: 100% 100%;
        float: right;
      }
      img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 86%;
        position: absolute;
        bottom: 0.3rem;
        left: 7%;
      }
    }
  }
  .main {
    background: #ff4900;
    .qd-main {
      box-sizing: border-box;
      padding: 0 0.2rem;
      position: relative;
      .qd-header {
        width: 100%;
        position: relative;
        z-index: 3;
      }
      .rule-icon2 {
        position: absolute;
        top: 1.6rem;
        right: 0.26rem;
        height: 0.76rem;
        width: 0.8rem;
        z-index: 5;
      }
      .qd-con {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 4rem;
        border-left: 0.1rem solid #cb3d17;
        border-right: 0.1rem solid #cb3d17;
        border-bottom: 0.1rem solid #cb3d17;
        border-radius: 0.16rem;
        z-index: 0;
        margin-top: -0.4rem;
        background-color: #f3b44f;
        .rule-icon {
          position: absolute;
          top: 0;
          right: 0;
          height: 0.76rem;
          width: auto;
          z-index: 2;
        }

        .qd-label {
          position: absolute;
          left: 0;
          top: 0;
          width: 1.1rem;
          z-index: 0;
        }
        .times-con {
          width: 5.4rem;
          height: 0.6rem;
          margin: 0 auto;
          padding-top: 0.3rem;
          position: relative;
          img {
            width: 100%;
          }
          p {
            font-size: 0.44rem;
            color: #c81000;
            font-family: Arial-BoldMT;
            position: absolute;
            top: 0.4rem;
            right: 2rem;
            font-weight: bold;
          }
        }
        .qd-text {
          font-size: 0.22rem;
          color: #7a4f09;
          text-align: center;
          margin-top: 0.2rem;
        }
        .qd-times {
          position: relative;
          margin: 0.85rem auto 0;
          // overflow: hidden;
          width: 85%;
          // padding-left: 0.7rem;
          // padding-top: 0.35rem;
          height: 0.3rem;
          background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/jindu_bg.png")
            no-repeat;
          background-size: 100% 100%;
          // display: flex;
          // justify-content: space-between;
          .times-item {
            // min-height: 0.38rem;
            position: relative;
            // float: left;
            // margin-left: -0.1rem;
            display: block;
            float: left;
            width: 25%;
            height: 0.3rem;
            p {
              color: #aa5e03;
              font-size: 0.24rem;
              clear: both;
              margin-bottom: 0.2rem;
              margin-left: -0.16rem;
              height: 0.25rem;
              .qd-hb {
                width: auto;
                height: 0.8rem;
                position: absolute;
                top: -0.3rem;
                right: 0.3rem;
                z-index: 4;
              }
            }
            .point {
              position: absolute;
              width: auto;
              height: 0.38rem;
              z-index: 3;
              left: -0.16rem;
              top: -0.045rem;
            }
            .point-two {
              right: -0.16rem;
              left: auto;
            }
            .pointThree {
              left: -0.36rem;
            }
            .times-line {
              display: block;
              height: 0.2rem;
              position: relative;
              z-index: 0;
              margin-top: 0.04rem;
            }
          }
          .get-hb {
            width: 1.1rem;
            height: 0.8rem;
            position: absolute;
            right: -0.45rem;
            top: -0.8rem;
          }
        }
        .qd-btn {
          width: 4.4rem;
          height: 1rem;
          margin: 0.3rem auto 0;
        }
      }
    }
    .cj-main {
      box-sizing: border-box;
      position: relative;
      .cj-header {
        width: 88%;
        position: relative;
        z-index: 3;
        margin: 0 auto;
      }
      .rule-icon2 {
        position: absolute;
        top: 1.5rem;
        right: 0.4rem;
        height: 0.76rem;
        width: 0.8rem;
        z-index: 5;
      }
      .cj-con {
        width: 100%;
        height: 3rem;
        position: relative;
        z-index: 0;
        margin-top: -0.4rem;
        .rule-icon {
          position: absolute;
          top: 0;
          right: 0.4rem;
          height: 0.76rem;
          width: auto;
          z-index: 2;
        }

        .cj-bg {
          width: 100%;
        }
        .cj-btn {
          width: 35%;
          position: absolute;
          // top: 33%;
          left: 11%;
          bottom: 0.66rem;
        }
        .cj-btn-two {
          height: 1.2rem;
        }
        .shou {
          position: absolute;
          left: 2.7rem;
          bottom: 0.7rem;
          width: 0.85rem;
          height: auto;
          -webkit-transform: translateX(-20%);
          -moz-transform: translateX(-20%);
          -ms-transform: translateX(-20%);
          -o-transform: translateX(-20%);
          transform: translateX(-20%);
          transform-origin: 100% 100%;
          animation-duration: 2s;
          -webkit-animation-duration: 2s;
          animation-timing-function: ease;
          -webkit-animation-timing-function: ease;
          -webkit-animation-name: rotateto;
          animation-name: rotateto;
          animation-iteration-count: infinite;
          -webkit-animation-iteration-count: infinite;
        }
        @-webkit-keyframes rotateto {
          0% {
            -webkit-transform: translateX(-20%) rotate(5deg);
            transform: translateX(-20%) rotate(5deg);
          }
          50% {
            -webkit-transform: translateX(-20%) rotate(-5deg);
            transform: translateX(-20%) rotate(-5deg);
          }
          100% {
            -webkit-transform: translateX(-20%) rotate(5deg);
            transform: translateX(-20%) rotate(5deg);
          }
        }

        @keyframes rotateto {
          0% {
            -webkit-transform: translateX(-20%) rotate(5deg);
            transform: translateX(-20%) rotate(5deg);
          }
          50% {
            -webkit-transform: translateX(-20%) rotate(-5deg);
            transform: translateX(-20%) rotate(-5deg);
          }
          100% {
            -webkit-transform: translateX(-20%) rotate(5deg);
            transform: translateX(-20%) rotate(5deg);
          }
        }
        .cj-text {
          position: absolute;
          top: 32%;
          right: 10%;
          font-size: 0.26rem;
          font-weight: bold;
          color: #ffe4b8;
          line-height: 1;
          text-align: center;
          width: 3.1rem;
          span {
            color: #ffe400;
            font-size: 0.46rem;
            font-family: Arial-BoldMT;
          }
        }
      }
    }
    .list-main {
      position: relative;
      padding: 0 0.2rem;
      .list-header {
        width: 100%;
        position: relative;
        z-index: 3;
      }
      .list-con {
        min-height: 3rem;
        position: relative;
        box-sizing: border-box;
        width: 100%;
        // height: 4rem;
        border-left: 0.1rem solid #cb3d17;
        border-right: 0.1rem solid #cb3d17;
        border-bottom: 0.1rem solid #cb3d17;
        border-radius: 0.16rem;
        z-index: 0;
        margin-top: -0.5rem;
        background-color: #f1ca8f;
        padding: 0.5rem 0.1rem 0;
        ul {
          width: 100%;
          overflow: hidden;
          li {
            width: 49%;
            background-color: #fff;
            float: left;
            position: relative;
            border-radius: 0.2rem;
            overflow: hidden;
            margin-bottom: 0.2rem;
            .img {
              width: 100%;
              display: block;
              position: relative;
              padding-top: 100%;
              img {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                display: block;
              }
            }
            h5 {
              white-space: normal;
              font-size: 0.22rem;
              color: #333;
              padding: 0.1rem 0.2rem 0;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              height: 0.672rem;
              line-height: 1.4;
              font-family: "Microsoft YaHei";
            }
            p {
              padding: 0.3rem 0.2rem 0;
              font-size: 0.24rem;
              color: #ee0000;
              margin-bottom: 0.2rem;
              font-family: "Arial";
              position: relative;
              span {
                font-size: 0.3rem;
              }
              .shouy {
                position: absolute;
                right: 0.2rem;
                font-size: 0.18rem;
                height: 0.35rem;
                line-height: 0.35rem;
                border-radius: 0.2rem 0 0 0.2rem;
                padding: 0 0.1rem;
                background-color: #ff8a00;
                color: #fff;
              }
            }
            .but {
              display: block;
              text-align: center;
              img {
                display: inline-block;
                width: 3.08rem;
              }
            }
            .but_go {
              display: block;
              text-align: center;
              height: 0.72rem;
              position: relative;
              padding: 0 0.3rem 0.2rem;
              box-sizing: border-box;
              span {
                box-sizing: border-box;
                width: 100%;
                height: 0.5rem;
                color: #fff;
                font-size: 0.24rem;
                text-align: center;
                line-height: 0.5rem;
                background: linear-gradient(95deg, #fd2618 0%, #fb5315 100%);
                margin: 0 auto;
                display: block;
                border-radius: 0.26rem;
              }
            }
          }
          li:nth-of-type(2n) {
            float: right;
          }
        }
      }
      .more-btn {
        display: block;
        width: 18%;
        position: absolute;
        top: 1.4rem;
        left: 50%;
        margin-left: -9%;
        z-index: 4;
      }
    }
  }
}
.backgroundImgtwo {
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/bg_twomax.png")
    repeat-y;
  background-size: 100% 100%;
}
.backgroundImg {
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/bg-gloab.png")
    repeat-y;
  background-size: 100% auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/main.vue